import { Injectable } from "@angular/core"
import { FormGroup } from "@angular/forms"
import { RxFormGroup } from "@rxweb/reactive-form-validators"

@Injectable({
    providedIn: 'root',
})
export class FormValidatorService {
    validateForm(form:FormGroup|RxFormGroup): boolean {
        if (!form.valid) {
            for (let i in form.controls) {
                form.controls[i].markAsTouched();
                form.controls[i].updateValueAndValidity();                
            }
           
            Object.keys(form.controls).forEach((key: any) => {
                if (form.controls[key].status == "INVALID") {
                   console.log(key, form.controls[key]);
                }
            });
            console.log("Form is invalid", form);
            return false
        }
        else {
            return true
        }
    }

    getValidationMessage(
        form: FormGroup|RxFormGroup,
        controlName: string,
        customMessages: { [key: string]: string } = {}
    ): string | null {
        const control = form.get(controlName);
        if (!control || !control.errors || !(control.dirty || control.touched)) {
            return null;
        }

        const defaultMessages: { [key: string]: string } = {
            required: 'Este campo es obligatorio.',
            email: 'El formato del email no es válido.',
            minLength: 'El contenido debe tener un mínimo de ' + control.errors['minLength']?.refValues[1] + ' caracteres.',
            maxLength: 'El contenido supera la longitud máxima permitida de ' + control.errors['maxLength']?.refValues[1] + ' caracteres.',
            min: 'El valor es inferior al mínimo permitido.',
            max: 'El valor supera el máximo permitido.',
            pattern: 'El formato no es válido.'
        };

        const messages = {
            ...defaultMessages,
            ...customMessages
        };
        
        const errorKeys = Object.keys(control.errors);
        for (const key of errorKeys) {
            if (messages[key]) {
                return messages[key];
            }
        }

        return 'Revise el valor introducido.';
    }
}